import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { LoginPage } from "../login/login";

import { Http } from "@angular/http";

import config from "../../config/config";
/**
 * Generated class for the EsqueciPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-esqueci",
  templateUrl: "esqueci.html"
})
export class EsqueciPage {
  form = {};
  esqueci: any;
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,

    public navParams: NavParams
  ) {}

  ionViewDidLoad() {
    this.esqueci = this.navParams.get("esqueci");
  }
  recuperar(form) {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();

    this._http
      .post(config.urlAPI + "recover", form, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        console.log(res);
        if (res.error == 1) {
          let link = "https://sintufrj.org.br/contato/";
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: "Erro",
            subTitle: `Não consta informações para esse SIAPE, entrar em contato com a sede ou subsedes do SINTUFRJ.<br><a href='${link}'>Site</a>`,
            buttons: [
              {
                text: "OK",
                handler: data => {
                  this.navCtrl.setRoot(LoginPage);
                }
              }
            ]
          });
          alert.present();
        }
        if (res.error == 2) {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: "Sucesso",
            subTitle: `Sua senha foi enviada para o e-mail ${res.email}. Caso não tenha acesso a esse e-mail, entrar em contato com a sede ou subsede`,
            buttons: [
              {
                text: "OK",
                handler: data => {
                  this.navCtrl.setRoot(LoginPage);
                }
              }
            ]
          });
          alert.present();
        }
        if (res.error == 4) {
          let link = "https://sintufrj.org.br/contato/";
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: "",
            subTitle: `Não consta e-mail cadastrado em nossa base de dados, entrar em contato com a sede ou subsedes do SINTUFRJ.<br><a href='${link}'>Site</a>`,
            buttons: [
              {
                text: "OK",
                handler: data => {
                  this.navCtrl.setRoot(LoginPage);
                }
              }
            ]
          });
          alert.present();
        }
        if (res.error == 3) {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: "Ocorreu um erro",
            subTitle: `Tente novamente mais tarde.`,
            buttons: [
              {
                text: "OK",
                handler: data => {
                  this.navCtrl.setRoot(LoginPage);
                }
              }
            ]
          });
          alert.present();
        }
      })
      .catch(error => {
        console.log(error);
        loading.dismiss();

        let alert = this.alertCtrl.create({
          title: "",
          subTitle: "Ocorreu um erro",
          buttons: ["ok"]
        });
        alert.present();
      });
  }
  voltarLogin() {
    this.navCtrl.setRoot(LoginPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/esqueci/esqueci.ts